import { useNavigate } from 'react-router';
import { Button } from 'reactstrap';
import { useMutation } from '@apollo/client';
import { useFormikContext } from 'formik';

import { DuplicateCropTemplateMutation } from '../../mutations';

// Handles copying a crop template.
const DuplicateTemplateButton = ({
  id,
  loading,
  refetchQuery,
  mutateAndSetState,
  ...props
}) => {
  const [mutate] = useMutation(DuplicateCropTemplateMutation);
  const navigate = useNavigate();
  const { isValid, dirty, isSubmitting } = useFormikContext();

  const duplicateTemplate = () => {
    mutateAndSetState(() =>
      mutate({
        variables: { id },
        refetchQueries: [{ query: refetchQuery, variables: { id } }],
      }).then((response) => {
        const { result } = response.data?.duplicateCropTemplate || {};
        if (result) {
          navigate(`../../${result.id}/edit`, { relative: 'path' });
        }
        return response;
      }),
    );
  };

  return (
    !!id && (
      <Button
        color="secondary"
        type="button"
        onClick={duplicateTemplate}
        className="mr-2"
        disabled={!isValid || dirty || isSubmitting || loading}
        {...props}
      >
        Duplicate Template
      </Button>
    )
  );
};

export default DuplicateTemplateButton;
